import { createFeatureSelector, createSelector, Action } from '@ngrx/store';
import { ApplicationState } from '../types';
import { FEATURE_NAME_CORE } from '../reducer/core.reducer';

export const getCoreState =
  createFeatureSelector<ApplicationState>(FEATURE_NAME_CORE);

export const getActionsToRetry = (state: ApplicationState): Action[] =>
  state?.actionsToRetry || [];

export const selectActionsToRetry = createSelector(
  getCoreState,
  getActionsToRetry
);
